<template>
  <div class="select-action">
    <form
      :action="currAction ? currAction.formAction : ''"
      :method="formMethod"
      @submit="onSubmitForm"
      class="select-action__form"
      ref="selectActionForm"
    >
      <fieldset class="fieldset fieldset--inline fieldset--sm fieldset--light">
        <m4-form-field type="select" name="bulkAction" value="" @change="onChangeAction">
          <option value="">Bulk actions</option>
          <option v-for="(action, i) in actions" :key="i" :value="action.formAction">
            {{ action.title }}
          </option>
        </m4-form-field>
        <input v-for="(rowId, i) in checkedRows" :key="i" type="hidden" :name="hiddenFieldName" :value="rowId" />
      </fieldset>
      <m4-button type="submit" size="sm" :variant="currAction && checkedRows.length > 0 ? 'info' : ''" name="send">
        {{ btnTitle }}
      </m4-button>
    </form>
    <m4-dialog
      v-if="showConfirmDialogMessage"
      :init-show="true"
      @onSubmitDialog="onSubmitDialog"
      :btn-title="submitBtnTitle"
      @closeModal="closeModal"
    >
      {{ confirmDialogMessage }}
    </m4-dialog>
    <m4-dialog v-if="showSelectRowsMessage" :init-show="true" @closeModal="closeModal">
      {{ selectRowsMessage }}
    </m4-dialog>
    <m4-dialog v-if="showSelectActionMessage" :init-show="true" @closeModal="closeModal">
      {{ selectActionMessage }}
    </m4-dialog>
  </div>
</template>

<script>
export default {
  name: "M4SelectAction",
  data() {
    return {
      currAction: null,
      submit: false,
      dialogSent: false
    };
  },
  props: {
    formMethod: {
      type: String,
      default() {
        return "post";
      }
    },
    actions: {
      type: Array,
      required: true
    },
    checkedRows: {
      type: Array,
      default() {
        return [];
      }
    },
    hiddenFieldName: {
      type: String,
      default() {
        return "bulk_ids[]";
      }
    },
    btnTitle: {
      type: String,
      default() {
        return "Apply";
      }
    },
    submitBtnTitle: {
      type: String,
      default() {
        return "Submit";
      }
    },
    selectRowsMessage: {
      type: String,
      default() {
        return "Please, select at least one record";
      }
    },
    selectActionMessage: {
      type: String,
      default() {
        return "Please, select an action first";
      }
    }
  },
  computed: {
    confirmDialogMessage() {
      if (this.currAction && this.currAction.confirmMessage != undefined) {
        return this.currAction.confirmMessage;
      }
      return false;
    },
    showConfirmDialogMessage() {
      return this.checkedRows.length > 0 && this.submit && this.currAction && this.currAction.confirmMessage;
    },
    showSelectRowsMessage() {
      return this.currAction && this.checkedRows.length === 0 && this.submit;
    },
    showSelectActionMessage() {
      return !this.currAction && this.submit;
    }
  },
  methods: {
    onChangeAction(e) {
      this.submit = 0;
      this.dialogSent = false;

      let wasChanged = false;
      this.actions.map((action) => {
        if (e.target.value === action.formAction) {
          this.currAction = action;
          wasChanged = true;
        }
      });

      if (wasChanged === false) {
        this.currAction = null;
      }
    },
    closeModal() {
      this.submit = false;
    },
    onSubmitForm(e) {
      this.submit = true;

      if (this.checkedRows.length > 0 && this.currAction && (!this.currAction.confirmMessage || this.dialogSent)) {
        return true;
      }

      e.preventDefault();
    },
    onSubmitDialog() {
      this.dialogSent = true;
      this.$refs.selectActionForm.submit();
    }
  }
};
</script>
